import { render, staticRenderFns } from "./ChangeRole.vue?vue&type=template&id=708935b0&"
import script from "./ChangeRole.vue?vue&type=script&lang=js&"
export * from "./ChangeRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports